"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Modals/QueueMessages/SplitSendButton.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Popover = require('web/components/Popover'); var _Popover2 = _interopRequireDefault(_Popover);



















const LATER = 'Schedule for later'

/* Send dialog v2 (D-82): Send now ▾ as two sibling buttons, like the chat
 * composer's. The chevron opens Schedule for later in a popover, right-aligned
 * under the button, with focus on its first field; Cancel, Escape or a press
 * outside closes only the popover and puts focus back on the chevron. */
const SplitSendButton = ({
  label, disabled, onSend, isOpen, onOpenChange,
  scheduleLabel, scheduleDisabled, onSchedule, isBusy = false, children,
}) => {
  const moreRef = _react.useRef(null)
  const id = _react.useId.call(void 0, )

  _react.useEffect.call(void 0, 
    () => {
      if (isOpen) _optionalChain([document, 'access', _ => _.getElementById, 'call', _2 => _2(id), 'optionalAccess', _3 => _3.querySelector, 'call', _4 => _4('input, button'), 'optionalAccess', _5 => _5.focus, 'call', _6 => _6()])
    },
    [isOpen, id],
  )

  const close = (reason) => {
    if (isBusy) return
    onOpenChange(false)
    const toChevron = () => _optionalChain([moreRef, 'access', _7 => _7.current, 'optionalAccess', _8 => _8.focus, 'call', _9 => _9()])
    // A press outside moves focus itself once it lands; back to the
    // chevron only if it landed nowhere.
    if (reason !== 'outside') toChevron()
    else setTimeout(() => { if (!document.activeElement || document.activeElement === document.body) toChevron() })
  }

  return (
    _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'broadcast-send--split', isOpen && 'broadcast-send--split-open'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
      , _react2.default.createElement('button', {
        type: "button",
        className: "blm-btn blm-btn--primary broadcast-send--split-main"  ,
        disabled: disabled,
        onClick: onSend, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}

        ,  label 
      )
      , _react2.default.createElement('button', {
        ref: moreRef,
        type: "button",
        className: "blm-btn blm-btn--primary broadcast-send--split-more"  ,
        'aria-label': LATER,
        title: LATER,
        'aria-haspopup': "dialog",
        'aria-expanded': isOpen,
        disabled: disabled,
        onClick: () => isOpen ? close('escape') : onOpenChange(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}

        , _react2.default.createElement('img', { alt: "", src: "/assets/icons/dropdown-down-white.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}} )
      )
      ,  isOpen && (
        _react2.default.createElement(_Popover2.default, {
          id: id,
          anchorRef: moreRef,
          align: "right",
          onClose: close,
          role: "dialog",
          'aria-label': LATER,
          className: "broadcast-popover broadcast-send--pop" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}

          , _react2.default.createElement('div', { className: "broadcast-popover--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}},  LATER )
          ,  children 
          , _react2.default.createElement('div', { className: "broadcast-popover--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}
            , _react2.default.createElement('button', { type: "button", className: "broadcast-popover--remove", disabled: isBusy, onClick: () => close('escape'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}, "Cancel"

            )
            , _react2.default.createElement('button', {
              type: "button",
              className: "blm-btn blm-btn--primary broadcast-send--pop-go"  ,
              disabled: scheduleDisabled,
              onClick: onSchedule, __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}

              ,  scheduleLabel 
            )
          )
        )
      )
    )
  )
}

exports. default = SplitSendButton
